import React from "react";
import {useTranslation} from "react-i18next";
import moment from "moment";

import Typography from "@mui/material/Typography";
import { Check, HourglassTop, FiberNew } from "@vedmarket/ui-kit";

import {COLORS} from "../../../../../../../config/constants";
import {useSupportStatuses} from "../../../../support-hooks";

type Props = {
  item: SupportRequest
}

const STATUS_LABEL_KEYS: Record<SupportRequestStatus, string> = {
  closed: 'support__text__requestStatusClosed',
  in_progress: 'support__text__requestStatusInProgress',
  new: 'support__text__requestStatusNew',
}

const STATUS_DATE_COLOR = COLORS.LIGHT_TEXT_DISABLED;
const STATUS_LABEL_COLOR = COLORS.BLACK;
const STATUS_ICON_COLORS: Record<SupportRequestStatus, string> = {
  closed: COLORS.LIGHT_TEXT_DISABLED,
  in_progress: COLORS.WARNING,
  new: COLORS.BLUE_DARK,
}

const Status = ({item}: Props) => {

  const { t } = useTranslation();

  const statuses = useSupportStatuses();

  const statusLabel = statuses.find(({value}) => value === item.status)?.label;

  const getStatusIcon = () => {
    const iconStyle = {fill: STATUS_ICON_COLORS[item.status]};

    switch (item.status) {
      case 'closed':
        return <Check className='support-requests-table__status-icon' style={iconStyle} />
      case 'new':
        return <FiberNew className='support-requests-table__status-icon' style={iconStyle} />
      case 'in_progress':
      default:
        return <HourglassTop className='support-requests-table__status-icon' style={iconStyle} />
    }
  }

  return (
    <div className='support-requests-table__status'>
      {getStatusIcon()}
      <div>
        <Typography
          variant='body2'
          style={{color: STATUS_LABEL_COLOR}}
          sx={{letterSpacing: 0, lineHeight: '20px'}}
        >
          {statusLabel || t(STATUS_LABEL_KEYS[item.status])}
        </Typography>
        <Typography
          variant='body2'
          style={{color: STATUS_DATE_COLOR}}
          sx={{letterSpacing: 0, lineHeight: '20px'}}
        >
          {moment(item.statusUpdatedAt).format('DD.MM.YYYY')}
        </Typography>
        <Typography
          variant='body2'
          style={{color: STATUS_DATE_COLOR}}
          sx={{letterSpacing: 0, lineHeight: '20px'}}
        >
          {moment(item.statusUpdatedAt).format('HH:mm:ss')}
        </Typography>
      </div>
    </div>
  );
};

export default Status;
